// src/components/store/sections/faqs/FaqV69BentohelpSunsetAmber.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV69BentohelpSunsetAmber(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={69}
      archKey="bento_help"
      archLabel="Bento Help Matrix"
      palName="SunsetAmber"
      grad="from-amber-500 via-orange-500 to-red-600"
      lightBg="bg-amber-50"
      textCol="text-amber-800"
      borderCol="border-amber-200"
      btnCls="bg-orange-600 hover:bg-orange-700"
      hexCol="#f59e0b"
      {...props}
    />
  );
}
